import React from "react";
import { FaMapMarkedAlt } from "react-icons/fa";

function DepartmentTableCard({ data = [] }) {
  return (
    <section className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20">
      <div className="flex flex-col gap-3 border-b border-slate-200 p-5 dark:border-white/10 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.14em] text-sky-700 dark:text-sky-200">
            Répartition géographique
          </p>

          <h2 className="mt-2 font-titre text-2xl font-bold text-slate-950 dark:text-white">
            Adhérents par département
          </h2>
        </div>

        <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-sky-100 text-sky-700 dark:bg-sky-500/10 dark:text-sky-200">
          <FaMapMarkedAlt />
        </div>
      </div>

      <div className="max-h-[520px] overflow-auto">
        <table className="w-full min-w-[760px] text-left">
          <thead className="sticky top-0 z-10">
            <tr className="border-b border-slate-200 bg-slate-50 text-[11px] font-bold uppercase tracking-[0.14em] text-slate-400 dark:border-white/10 dark:bg-slate-950">
              <th className="px-4 py-3">Département</th>
              <th className="px-4 py-3">Région</th>
              <th className="px-4 py-3 text-right">Adhérents</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-slate-100 dark:divide-white/10">
            {data.map((dept) => (
              <tr
                key={dept.code}
                className="text-sm transition hover:bg-sky-50/60 dark:hover:bg-white/[0.03]"
              >
                <td className="px-4 py-3">
                  <p className="font-bold text-slate-950 dark:text-white">
                    {dept.code} - {dept.departement}
                  </p>
                </td>

                <td className="px-4 py-3 text-sm font-medium text-slate-500 dark:text-white/55">
                  {dept.region}
                </td>

                <td className="px-4 py-3 text-right">
                  <span className="inline-flex min-h-8 items-center rounded-2xl bg-sky-100 px-3 text-xs font-bold text-sky-700 dark:bg-sky-500/10 dark:text-sky-200">
                    {dept.count}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {!data.length && (
          <div className="p-8 text-center text-sm font-bold text-slate-400">
            Aucun adhérent à afficher.
          </div>
        )}
      </div>
    </section>
  );
}

export default DepartmentTableCard;